<template>
    <template v-if = "(item.icon !=='' && item.icon !== undefined) || item.tag == 'el-icon-menu-item'">
      <!-- item.icon 有值，则还有子菜单， 左侧一级菜单一定是带 图标的菜单 el-icon-menu-item -->
      <el-sub-menu :index="item.id">
        <template #title>
          <el-icon><component :is="item.icon" /></el-icon>
          <span>{{getI18n(item.label)}}</span>
        </template>
        <MenuItemRender :item=subItem v-for="(subItem) in item.children" :key="subItem.id"></MenuItemRender>
      </el-sub-menu>
    </template>
    <template v-else >
      <!-- 顶部菜单 或 左侧的普通菜单 -->
      <el-menu-item :index="item.id" v-if = "item.tag == 'el-menu-item'">{{getI18n(item.label)}}</el-menu-item>
      <!-- 菜单分割线 -->
      <div class="flex-grow" v-else-if = "item.tag == 'menu-placeholder'"></div>
      <!-- else 一定是 el-sub-menu， 左侧多级菜单还有子菜单的但无图标时情况 -->
      <el-sub-menu :index="item.id" v-else>
          <template #title>{{getI18n(item.label)}}</template>
          <MenuItemRender :item=subItem v-for="(subItem) in item.children" :key="subItem.id"></MenuItemRender>
      </el-sub-menu>
    </template>
</template>

<script lang="ts">
import { defineComponent, defineProps } from 'vue'
import { getI18n } from '../utils'
// 解决vs中的语法错误提示
export default defineComponent({
  name: 'MenuItemRender'
})
</script>

<script lang="ts" setup>
defineProps({
  item: Object
})
</script>
